import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useLanguageStore } from '../../store/languageStore';
import { Languages } from 'lucide-react';

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const { language, setLanguage, isRTL } = useLanguageStore();

  const handleToggle = () => {
    const newLang = language === 'ar' ? 'en' : 'ar';
    setLanguage(newLang);
    i18n.changeLanguage(newLang);
  };

        const currentLang = language === 'ar' ? 'عربي' : 'English';

  return (
    <motion.button
      onClick={handleToggle}
      className="btn btn-link text-dark p-2 position-relative d-flex align-items-center gap-2 border-0"
      style={{
        borderRadius: '0.75rem',
        transition: 'all 0.2s ease-in-out',
        textDecoration: 'none',
        minWidth: '100px',
        height: '40px',
        backgroundColor: 'rgba(249, 250, 251, 0.8)',
        border: '1px solid rgba(229, 231, 235, 0.8)',
      }}
      whileHover={{ 
        scale: 1.02,
        backgroundColor: 'rgba(14, 165, 233, 0.08)',
        borderColor: 'rgba(14, 165, 233, 0.3)',
        boxShadow: '0 2px 8px rgba(14, 165, 233, 0.15)',
      }}
      whileTap={{ scale: 0.95 }}
      title={language === 'ar' ?  'التبديل إلى العربية' : 'Switch to English'}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <motion.div
        key={language}
        initial={{ rotate: -180, scale: 0.8, opacity: 0 }}
        animate={{ 
          rotate: 0,
          scale: 1,
          opacity: 1,
        }}
        exit={{ rotate: 180, scale: 0.8, opacity: 0 }}
        transition={{ 
          duration: 0.4,
          ease: 'easeInOut',
        }}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          background: language === 'ar' 
            ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
            : 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
          boxShadow: '0 2px 8px rgba(14, 165, 233, 0.3)',
        }}
        whileHover={{ scale: 1.1 }}
      >
        <Languages 
          className="h-4 w-4" 
          style={{ 
            color: 'white',
          }} 
        />
      </motion.div>
      
      <AnimatePresence mode="wait">
        <motion.span
          key={language}
          initial={{ opacity: 0, x: isRTL ? 10 : -10, scale: 0.9 }}
          animate={{ opacity: 1, x: 0, scale: 1 }}
          exit={{ opacity: 0, x: isRTL ? -10 : 10, scale: 0.9 }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
          className="fw-semibold d-flex align-items-center"
          style={{
            fontSize: '0.875rem',
            color: 'var(--color-gray-700)',
            minWidth: '60px',
            justifyContent: isRTL ? 'flex-end' : 'flex-start',
            fontFamily: language === 'ar' ? 'var(--font-family-arabic)' : 'var(--font-family-base)',
            letterSpacing: language === 'ar' ? '0' : '0.01em',
          }}
        >
          {currentLang}
        </motion.span>
      </AnimatePresence>
    </motion.button>
  );
};

